import { FC } from 'react';

import { ScrollView, View } from '@rbilabs/universal-components';

import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { WEB_APP_MAX_WIDTH } from 'utils/constants';
import { isWeb } from 'utils/environment';

import { IScrollContainerProps } from './types';

export const ScrollContainer: FC<IScrollContainerProps> = ({ children, width }) => {
  const isDesktop = useIsDesktopBreakpoint();
  if (isDesktop && isWeb) {
    return (
      <ScrollView
        flex={1}
        overflowX="hidden"
        nativeID="main"
        px={(width - WEB_APP_MAX_WIDTH) / 2}
        showsVerticalScrollIndicator
        contentContainerStyle={{ flexGrow: 1 }}
      >
        {children}
      </ScrollView>
    );
  }
  return (
    <View flex={1} overflowX="hidden" nativeID="main">
      {children}
    </View>
  );
};
